module.exports = __webpack_public_path__ + "img/inst-modal-2.d2f21fd5.png";